var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-complaints-view',{attrs:{"values":_vm.values,"mail-to-link":_vm.mailToLink,"has-support-email":!!_vm.supportEmail},on:{"update":function (data) { return (_vm.values = Object.assign({}, _vm.values, data)); }}})}
var staticRenderFns = []

export { render, staticRenderFns }